import { AxiosResponse } from 'axios';

// Helper.
import API from '../Api';
// Types.
import { NewsEntry } from '../types/news';


export const fetchNews = async (userId: number, endpoint: string): Promise<NewsEntry[]> => {
  if (!endpoint) {
    endpoint = 'anon';
  }

  const faqs: AxiosResponse<NewsEntry[]> = await API({
    method: 'get',
    url: `/news/${endpoint}/${userId}`,
    headers: {
      Authorization: `Bearer ${sessionStorage.getItem('token')}`,
    }
  });

  return faqs.data;
}
